import { takeLatest, put, call } from 'redux-saga/effects';
import { storage } from '@commons/storage';

import {
    getListCustoProcedimentos,
    getListCustoDespesaDireta,
    getListCustoInsumos,
    getListCustoMaquinarios,
    getListCustoFuncionarios,
} from '../service';
import {
    CONFIG_SESSION,
    CUSTO_LIST_TABLE_DASHBOARD,
    CUSTO_LIST_PROCEDIMENTOS_PENDING,
    CUSTO_LIST_PROCEDIMENTOS_SUCCESS,
    CUSTO_LIST_PROCEDIMENTOS_FAILURE,
    CUSTO_LIST_DESPESAS_DIRETAS_PENDING,
    CUSTO_LIST_DESPESAS_DIRETAS_SUCCESS,
    CUSTO_LIST_DESPESAS_DIRETAS_FAILURE,
    CUSTO_LIST_INSUMOS_PENDING,
    CUSTO_LIST_INSUMOS_SUCCESS,
    CUSTO_LIST_INSUMOS_FAILURE,
    CUSTO_LIST_MAQUINARIOS_PENDING,
    CUSTO_LIST_MAQUINARIOS_SUCCESS,
    CUSTO_LIST_MAQUINARIOS_FAILURE,
    CUSTO_LIST_FUNCIONARIOS_PENDING,
    CUSTO_LIST_FUNCIONARIOS_SUCCESS,
    CUSTO_LIST_FUNCIONARIOS_FAILURE,

} from '@handler';
import { formatDateDDMMYYYY } from '@components/common/format';

function* sagaListCustos(action) {
    yield put({ type: CUSTO_LIST_PROCEDIMENTOS_PENDING });
    yield put({ type: CUSTO_LIST_DESPESAS_DIRETAS_PENDING });
    yield put({ type: CUSTO_LIST_INSUMOS_PENDING });
    yield put({ type: CUSTO_LIST_MAQUINARIOS_PENDING });
    yield put({ type: CUSTO_LIST_FUNCIONARIOS_PENDING });

    try {
        const idFazenda = JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada === null ? -1 : JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id;
        const idSafra = JSON.parse(storage.get(CONFIG_SESSION)).safraAtiva === null ? -1 : JSON.parse(storage.get(CONFIG_SESSION)).safraAtiva.id;

        const dataInicial = formatDateDDMMYYYY(action.dataInicial);
        const dataFinal = formatDateDDMMYYYY(action.dataFinal);

        const [
            dadosListCustosProcedimentos,
            dadosListCustosDespesasDireta,
            dadosListCustosInsumos,
            dadosListCustosMaquinarios,
            dadosListCustosFuncionarios,
        ] = yield [
            call(getListCustoProcedimentos, idFazenda, idSafra, dataInicial, dataFinal),
            call(getListCustoDespesaDireta, idFazenda, idSafra, dataInicial, dataFinal),
            call(getListCustoInsumos, idFazenda, idSafra, dataInicial, dataFinal),
            call(getListCustoMaquinarios, idFazenda, idSafra, dataInicial, dataFinal),
            call(getListCustoFuncionarios, idFazenda, idSafra, dataInicial, dataFinal),
        ];

        yield put({ type: CUSTO_LIST_PROCEDIMENTOS_SUCCESS, payload: dadosListCustosProcedimentos });
        yield put({ type: CUSTO_LIST_DESPESAS_DIRETAS_SUCCESS, payload: dadosListCustosDespesasDireta });
        yield put({ type: CUSTO_LIST_INSUMOS_SUCCESS, payload: dadosListCustosInsumos });
        yield put({ type: CUSTO_LIST_MAQUINARIOS_SUCCESS, payload: dadosListCustosMaquinarios });
        yield put({ type: CUSTO_LIST_FUNCIONARIOS_SUCCESS, payload:dadosListCustosFuncionarios });
    } catch (error) {
        yield put({ type: CUSTO_LIST_PROCEDIMENTOS_FAILURE });
        yield put({ type: CUSTO_LIST_DESPESAS_DIRETAS_FAILURE });
        yield put({ type: CUSTO_LIST_INSUMOS_FAILURE });
        yield put({ type: CUSTO_LIST_MAQUINARIOS_FAILURE });
        yield put({ type: CUSTO_LIST_FUNCIONARIOS_FAILURE });
    }
}

export default function* watchListCustos() {
    yield takeLatest(CUSTO_LIST_TABLE_DASHBOARD, sagaListCustos);
}
